import React from "react";
import { Controller } from "react-hook-form";

import { cn } from "../../utils/utils";

const ControlSelect = (props) => {
  const {
    type,
    control,
    name,
    label,
    onChange: customOnChange,
    errors,
    className,
    options,
    hidden,
    rules,
  } = props;

  const disabled = name === "secondaryOption" && !options.length;

  return (
    <div>
      <div className={cn("col-span-2 xl:col-span-1 flex flex-col gap-2 relative", className)}>
        <label htmlFor={name}>{label}</label>
        <Controller
          control={control}
          name={name}
          rules={rules}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <>
              <select
                type={type}
                name={name}
                disabled={disabled}
                onChange={(e) => {
                  ////console.log(Number(e.target.value),"e")
                  onChange(e); // React Hook Form onChange
                  if (customOnChange) customOnChange(e); // Custom onChange if provided
                }}
                onBlur={onBlur}
                value={value}
                ref={ref}
                onWheel={(e) => e.target.blur()}
                className={cn(
                  "h-[52px] px-4 outline-none rounded-v-md w-full border-2 appearance-none disabled:hidden",
                  errors ? "border-red-500" : "border-neutral-30",
                )}
              >
                {!disabled && (
                  <option value="" hidden={hidden}>
                    یکی را انتخاب کنید
                  </option>
                )}
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.title}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute top-1/2 translate-y-[-50%] left-0 flex items-center px-2 text-gray-700">
                {!disabled && (
                  <svg
                    className="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                )}
              </div>
            </>
          )}
        />
      </div>
      {errors?.message && <span className="text-red-500 text-sm">{errors.message}</span>}
    </div>
  );
};

export default ControlSelect;
